import { render } from "./ImpressaoTransferenciaInterna.vue?vue&type=template&id=a67cc464"
import script from "./ImpressaoTransferenciaInterna.vue?vue&type=script&lang=js"
export * from "./ImpressaoTransferenciaInterna.vue?vue&type=script&lang=js"

import "./ImpressaoTransferenciaInterna.vue?vue&type=style&index=0&id=a67cc464&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__